
export default {
    props: {
        options: { type: Array, required: true },
        value: { type: [Array, String, Number, Boolean], default: null },
        radio: { type: Boolean, default: false },
        twoCol: { type: Boolean, default: false },
    },
    methods: {
        isChecked (opt) {
            return this.radio ? this.value === opt.value : (this.value || []).includes(opt.value)
        },
        toggle (opt) {
            if (this.radio) {
                this.$emit('input', opt.value)
                return
            }
            const current = [].concat(this.value || [])
            if (opt.none) {
                this.$emit('input', current.includes(opt.value) ? [] : [opt.value])
                return
            }
            const noneValues = this.options.filter(o => o.none).map(o => o.value)
            const without = current.filter(v => v !== opt.value && !noneValues.includes(v))
            this.$emit('input', current.includes(opt.value) ? without : [...without, opt.value])
        },
    },
}
